// src/pages/Leite/propriedade/IndicadorCard.jsx
import React from 'react';
import { Box, ButtonBase, Paper, Skeleton, Stack, Typography, alpha } from '@mui/material';

/**
 * Indicador do painel: ícone, rótulo, número grande e uma linha de apoio. Com
 * `onClick`, o card inteiro leva ao detalhe (ex.: plano de ações).
 */
/** `carregando`: esqueleto no lugar do número e do apoio, com a mesma altura do conteúdo. */
export default function IndicadorCard({ icone, cor, rotulo, valor, sufixo, apoio, rodape, onClick, carregando = false }) {
    const conteudo = (
        <Stack direction="row" spacing={2} sx={{ p: { xs: 2, sm: 2.5 }, width: '100%', textAlign: 'left' }}>
            <Box sx={{ p: 1.1, borderRadius: 2, bgcolor: alpha(cor, 0.12), color: cor, display: 'flex', height: 'fit-content' }}>
                {icone}
            </Box>
            <Box sx={{ minWidth: 0, flex: 1 }}>
                <Typography variant="body2" color="text.secondary">{rotulo}</Typography>
                {carregando ? (
                    <>
                        <Skeleton variant="rounded" width={72} height={34} sx={{ mt: 0.75, borderRadius: 1.5 }} />
                        <Skeleton width="70%" sx={{ mt: 0.75 }} />
                    </>
                ) : (
                    <>
                        <Stack direction="row" spacing={0.5} alignItems="baseline" sx={{ mt: 0.5 }}>
                            <Typography fontWeight={800} sx={{ fontSize: '1.8rem', lineHeight: 1.2 }}>{valor}</Typography>
                            {sufixo && <Typography color="text.secondary">{sufixo}</Typography>}
                        </Stack>
                        {apoio && (
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>{apoio}</Typography>
                        )}
                        {rodape}
                    </>
                )}
            </Box>
        </Stack>
    );
    return (
        <Paper variant="outlined" sx={{ height: '100%', borderRadius: 3, display: 'flex', overflow: 'hidden' }}>
            {onClick ? (
                <ButtonBase onClick={onClick} sx={{ width: '100%', alignItems: 'stretch', '&:hover': { bgcolor: 'action.hover' } }}>
                    {conteudo}
                </ButtonBase>
            ) : (
                conteudo
            )}
        </Paper>
    );
}
